<div class="p-2 flex justify-between items-center border-bottom">
  <span class="text-xl">{{ 'catalog.multi_image_download.title' | transloco }}</span>
  <button (click)="onClose()" [title]="'ui.buttons.close' | transloco" class="error-icon-button" mat-icon-button>
    <mat-icon>close</mat-icon>
  </button>
</div>

<div class="overflow-auto grow">
  <cat-checklist
    (cancelSelection)="onCancelSelection()"
    (selectChange)="onSelect($event)"
    [checked]="checked$ | async"
    [countChecked]="countChecked$ | async"
    [maxBatchSize]="maxBatchSize$ | async"
    [selected]="selected$ | async"
    [disabled]="downloadInProgress$ | async"
  ></cat-checklist>
</div>

@if (selected$ | async; as selected) {
  <div class="mt-2">
    <cat-image-detail (detail)="onDetail($event)" (uncheck)="onUncheck($event)" [selected]="selected"
                      [disabled]="downloadInProgress$ | async"></cat-image-detail>
  </div>
}

<div class="p-2 border-top">
  <cat-download-form
    (download)="onDownload($event)"
    [countChecked]="countChecked$ | async"
    [resolutions]="resolutions$ | async"
    [disabled]="downloadInProgress$ | async"
  ></cat-download-form>
</div>
